import ReactMarkdown from "react-markdown";
import { Sparkles, User } from "lucide-react";
import { ActionCard } from "./ActionCard";
import type { Msg, ActionProposal } from "./types";

interface ChatMessageProps {
  msg: Msg;
  actions?: ActionProposal[];
  onValidateAction?: (id: string) => void;
  onPriorityChange?: (id: string, priority: ActionProposal["priority"]) => void;
}

export const ChatMessage = ({ msg, actions, onValidateAction, onPriorityChange }: ChatMessageProps) => {
  if (msg.role === "user") {
    return (
      <div className="flex gap-2.5 justify-end">
        <div className="max-w-[80%] rounded-xl px-3.5 py-2.5 text-sm leading-relaxed bg-primary text-primary-foreground whitespace-pre-wrap">
          {msg.content}
        </div>
        <div className="h-7 w-7 rounded-lg bg-secondary flex items-center justify-center shrink-0 mt-0.5">
          <User className="h-3.5 w-3.5 text-muted-foreground" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-2.5 justify-start">
      <div className="h-7 w-7 rounded-lg bg-primary/15 flex items-center justify-center shrink-0 mt-0.5">
        <Sparkles className="h-3.5 w-3.5 text-primary" />
      </div>
      <div className="max-w-[85%] space-y-2">
        <div className="rounded-xl px-3.5 py-2.5 text-sm leading-relaxed bg-secondary/60 border border-border/50 prose prose-sm prose-invert prose-headings:text-white prose-headings:font-semibold prose-headings:mt-3 prose-headings:mb-1 prose-p:my-1 prose-p:text-white prose-ul:my-1 prose-ol:my-1 prose-li:my-0.5 prose-li:text-white prose-strong:text-primary prose-a:text-primary max-w-none text-white">
          <ReactMarkdown>{msg.content}</ReactMarkdown>
        </div>
        {/* Action proposals */}
        {actions && actions.length > 0 && (
          <div className="space-y-2 pl-1">
            <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
              📋 Actions proposées — Choisissez vos priorités
            </p>
            {actions.map((action) => (
              <ActionCard
                key={action.id}
                action={action}
                onValidate={onValidateAction || (() => {})}
                onPriorityChange={onPriorityChange || (() => {})}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
